var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.examples),function(example,index){return _c('ProgressBar',{key:index,attrs:{"unlimited":example.unlimited,"max":example.max,"balance":example.balance}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }